export default [
  {
    path: '/manuals',
    component: '__base',
    redirect: '/manuals/index',
    children: [
      {
        path: 'index',
        component: 'Manuals.vue',
        meta: { title: 'Manuals', allow: true },
      },
    ],
  },
];
